document.addEventListener("DOMContentLoaded", () => {
	const subtitle = document.querySelector(".for-reset-password .page-card-subtitle");
	if (!subtitle) return;

	subtitle.textContent =
		"Password must be at least 8 characters with uppercase, lowercase, a number and a special character. " +
		"Common words (admin, password, welcome), names, years and patterns like Word@123 are not allowed, " +
		"and you cannot reuse your current password.";
});
